import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { TopMatterWithDetails } from 'reservations/account/components/TopMatterWithDetails';
import { MaxPartySizeText } from 'reservations/availabilities/components/MaxPartySizeText';
import PartySize from 'reservations/availabilities/components/PartySize';
import { useIsBeyondMaxPartySize } from 'reservations/availabilities/hooks/useIsBeyondMaxPartySize';
import { LayoutWithGutter } from 'reservations/base/components/LayoutWithGutter';
import { ModalContainer } from 'reservations/base/components/ModalContainer';
import { useRouteIfAppDisabled } from 'reservations/base/hooks/useRouteIfAppDisabled';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { WAITPARTY } from 'reservations/booking/types';
import BackgroundOverlayImageWrapper from 'reservations/brand/components/BackgroundOverlayImageWrapper';
import Form from 'reservations/form/components/Form';
import JoinWaitlistButton from 'reservations/waitlist/components/JoinWaitlistButton';
import WaitlistProvider from 'reservations/waitlist/providers/WaitlistProvider';

type Props = {
  slug: string;
};

function WaitlistOnlyGrid() {
  useRouteIfAppDisabled();
  const { open } = useModal();
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue('bookingType', WAITPARTY);
  }, []);

  const handleWaitlistClick = () => {
    open(ModalType.BookingFields);
  };

  const isBeyondMaxPartySize = useIsBeyondMaxPartySize();

  return (
    <Grid container direction="column" spacing="36px" sx={{ px: '16px' }}>
      <Grid item>
        <Box sx={{ px: '16px' }}>
          <PartySize />
        </Box>
      </Grid>
      <Grid item>
        {isBeyondMaxPartySize ? (
          <MaxPartySizeText />
        ) : (
          <JoinWaitlistButton
            sxProps={{ maxWidth: '95%' }}
            showNumberOfPartiesAhead
            onClick={handleWaitlistClick}
          />
        )}
      </Grid>
    </Grid>
  );
}

const WaitlistOnlyScreen = ({ slug }: Props) => (
  <>
    <Box sx={{ pt: '130px' }}>
      <TopMatterWithDetails />
    </Box>
    <Form>
      <BackgroundOverlayImageWrapper additionalHeight={400}>
        <WaitlistProvider slug={slug}>
          <LayoutWithGutter>
            <WaitlistOnlyGrid />
            <ModalContainer />
          </LayoutWithGutter>
        </WaitlistProvider>
      </BackgroundOverlayImageWrapper>
    </Form>
  </>
);

export default WaitlistOnlyScreen;
